import {
  DELETE_PROJECTS_REQUEST,
  DELETE_PROJECTS_ERROR,
  DELETE_PROJECTS_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/deleteEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default entity => async (state = initialState, action) => {

  context.init(context);

  context.DELETE_ENTITIES_REQUEST = DELETE_PROJECTS_REQUEST;
  context.DELETE_ENTITIES_ERROR = DELETE_PROJECTS_ERROR;
  context.DELETE_ENTITIES_SUCCESS = DELETE_PROJECTS_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "projects";
  context.entityLocation = RESOURCES.Projects;

  return context.execute(context)(entity)(state, action);
};

